import React, { useEffect, useState } from 'react';
import Seperator from '../../Components/DashboardComponent/separator/Separator';
import { Link, useNavigate } from "react-router-dom";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate, useMsal
} from "@azure/msal-react";

const LoginPage = (props) => {

    const navigate = useNavigate();
    const [isLoggedIn, setisLoggedIn] = useState(false);
    const { instance } = useMsal();
    useEffect(() => {

        var addBodyDashboardClass = document.getElementsByTagName('body');
        addBodyDashboardClass[0].classList.add('dashboardWrapperCustom');

         /*Checking if user is not loggedIn*/
        if (!isLoggedIn) {
            /*navigate("/login");*/
        } else {
            /*navigate("/dashboard-advantage");*/
        }
    }, [navigate, isLoggedIn]);


    return (<>

        {instance.loginRedirect(loginRequest)}

        <div className="DashboardWrapperChild">
            <div className="loginWrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 offset-md-2 d-flex align-items-center justify-content-center flex-column">
                            <img src={process.env.REACT_APP_PUBLIC_URL + '/assetsDashboard/img/logo.png'} className="logoLogin" />
                            <h2 className="loginHeading w-100">Sign In</h2>
                            <p className="loginsubHeading mb-2 w-100">Use your Trailboss Advantage account to log in.</p>
                            <Seperator />
                            <form className="form-horizontal formLogin mt-2 w-100 row">
                                <div className="form-group">
                                    <label>
                                        Email
                                    </label>
                                    <input type="text" className="form-control loginfield" placeholder="Email Id" />
                                </div>
                                <div className="form-group mt-3">
                                    <label>
                                        Password
                                    </label>
                                    <input type="password" className="form-control loginfield" placeholder="******" />
                                </div>
                                <div className="form-group mt-3">
                                    <div className="col-md-12">
                                        <p className="forgotPass">Forgot Password?</p>
                                    </div>
                                </div>
                                <div className="form-group mt-3 col-md-12">
                                    {isLoggedIn || (
                                        <button className="btn btnLogin" onClick={() => setisLoggedIn(true)}>
                                            Sign In
                                        </button>
                                    )}
                                </div>
                                <div className="form-group mt-3 col-md-12 text-center">
                                    <p className="registerLoginText">Register</p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/*<div className="container">*/}
                {/*    <div className="row">*/}
                {/*        <div className="col-md-12">*/}
                {/*            <p className="copyrightText">© 2023Horizon UI. All Rights Reserved. Made with love bySimmmple!</p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div className="loginBgImageWrapperBG">
                <div className="loginBgImageWrapper">
                    <div className="loginBgImageWrapperText">
                        <h3 className="colorWhite heaingLoginPage mb-4">Trailboss Advantage Log in.</h3>
                        <p className="colorWhite">
                            This site is for the use of those authorized by Trailboss Enterprises Inc. Improper or unauthorized use of this site may lead to criminal prosecution or other disciplinary action. Authorized use is governed by institutional policy and by state and federal laws, and each user is responsible for familiarity and compliance with their provisions. Usage may also be subject to monitoring and testing.
                        </p>
                        <p className="colorWhite">
                            Your computer/network account, or company email account will not work to log into Trailboss Advanatge. Please do not attempt to log into this site with your computer/network or email credentials or login. You must register your Trailboss Advantage account prior to accessing the Trailboss Advantage site.
                        </p>
                        <p>
                            <Link to="/" className="linkcolorWhite cursorPointer">See Our Website!</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default LoginPage;